import { useState } from 'react';
import Menu from '@creditflowresearch/uilib/Menu';
import UserProfileMenuTrigger from '@/creditflowresearch/ui/common/components/organisms/UserProfileMenuTrigger';
import { UserProfileMenuTemplateDesktop } from '@/creditflowresearch/ui/common/components/templates/UserProfileMenuTemplate';

import styles from './userProfileMenu.module.scss';

const UserProfileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={ styles.menuWrapper }>
      <Menu
        dataTest="userProfileMenu"
        open={ isOpen }
        setOpen={ setIsOpen }
        placement="bottom-end"
        usePortal={ false }
        offsetOptions={ { mainAxis: 0 } }
        contentClassName={ styles.menuContent }
        trigger={ <UserProfileMenuTrigger isActive={ isOpen } /> }
      >
        <UserProfileMenuTemplateDesktop onClose={ () => setIsOpen(false) } />
      </Menu>
    </div>
  );
};

export default UserProfileMenu;
